import { getList, getSelectList, getOne, refreshOne } from './getData'
import { setCreate, setDelete, setUpdate, setRandomMatches } from './setData'

export const state = {
  list: [],
  listSelect: [],
  idSelected: '',
  selected: {},
  loading: false,
  type: 'tournaments',
  type2: 'tournament',
  url: 'tournaments/',
  view: false
}

export const mutations = {
  updateList: (state, list) => {
    state.list = list || []
  },
  updateSelectList: (state, list) => {
    state.listSelect = []
    if (Array.isArray(list)) {
      list.forEach(item => state.listSelect.push(item))
    }
  },
  updateOne: (state, one) => {
    state.selected = one || {}
    if (one) state.idSelected = one._id
  },
  updateLoading: (state, loading) => {
    state.loading = loading
  },
  updateClearOne: state => {
    state.selected = {}
    state.idSelected = ''
  },
  updateView: (state, view = false) => {
    state.view = view
  }
}

export const actions = {
  async setInit({ commit, state }) {
    await getList(commit, state.url, state.type)
  },
  setInitSelect: (context, payload = {}) => getSelectList(context, payload),
  async setOne({ commit, state }, id) {
    return getOne(commit, id, state.url, state.type2)
  },
  async refresh(context, id) {
    return refreshOne(context, id, context.state.url, context.state.type2)
  },
  async setNew({ commit, state, dispatch }, one) {
    const result = await setCreate(one, state.url, state.type2)
    dispatch('refresh', result._id)
    getList(commit, state.url, state.type)
  },
  async setEliminate({ commit, state }, id) {
    await setDelete(id, state.url)
    getList(commit, state.url, state.type)
  },
  async setUpdate({ commit, state, dispatch }, one) {
    const result = await setUpdate(one, state.url, state.type2)
    dispatch('refresh', result._id)
    getList(commit, state.url, state.type)
    return result
  },
  async setRandomMatches({ commit, dispatch }, { tournamentId, phaseId }) {
    const result = await setRandomMatches(tournamentId, phaseId)
    commit('updateOne', result)
    dispatch('matches/query', { tournamentId }, { root: true })
    dispatch('matches/setRanking', { tournamentId }, { root: true })
    dispatch('matches/setResults', tournamentId, { root: true })
  },
  setClearOne: ({ commit }) => {
    commit('updateClearOne')
  }
}

export const getters = {
  selectList: state => {
    let result = []
    let activeList = state.list.filter(item => item.active)
    activeList.forEach(item => {
      result.push({
        text: item.name,
        value: item._id
      })
    })
    return result
  }
}
